// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Controls.css
// module id = 1167
// module chunks = 0 1 2